import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { Organization, Site } from '../../models/organization.model';

export interface PortfolioFiltersLocalState {
  selectedOrganizations: Organization[];
  selectedSites: Site[];

  appliedOrganizations: Organization[];
  appliedSites: Site[];
}

const initialState: PortfolioFiltersLocalState = {
  selectedOrganizations: [],
  selectedSites: [],
  appliedOrganizations: [],
  appliedSites: [],
};

export const PortfolioFiltersStore = signalStore(
  withState(initialState),
  withComputed(store => ({
    isOrganizationSelected: computed(() => (id: string) => store.selectedOrganizations().some(org => org.id === id)),
    isSiteSelected: computed(() => (id: string) => store.selectedSites().some(site => site.id === id)),
    hasPendingChanges: computed(() => true),
  })),
  withMethods(store => ({
    toggleOrganization(organization: Organization) {
      const current = store.selectedOrganizations();
      const exists = current.find(org => org.id === organization.id);

      const nextOrganizations = exists
        ? current.filter(org => org.id !== organization.id)
        : [...current, organization];

      const allowedOrgIds = new Set(nextOrganizations.map(org => org.id));
      const filteredSites = store.selectedSites().filter(site => !allowedOrgIds.size || allowedOrgIds.has(site.organizationId));

      patchState(store, {
        selectedOrganizations: nextOrganizations,
        selectedSites: filteredSites,
      });
    },
    toggleSite(site: Site) {
      const current = store.selectedSites();
      const exists = current.find(s => s.id === site.id);

      if (exists) {
        patchState(store, {
          selectedSites: current.filter(s => s.id !== site.id),
        });
      } else {
        const selectedOrgIds = new Set(store.selectedOrganizations().map(org => org.id));
        if (selectedOrgIds.size && !selectedOrgIds.has(site.organizationId)) {
          return;
        }

        patchState(store, {
          selectedSites: [...current, site],
        });
      }
    },
    reset() {
      patchState(store, {
        selectedOrganizations: [],
        selectedSites: [],
        appliedOrganizations: [],
        appliedSites: [],
      });
    },
    apply() {
      patchState(store, {
        appliedOrganizations: store.selectedOrganizations(),
        appliedSites: store.selectedSites(),
      });
    },
  }))
);
